import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
const CompletedShifts = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0">
              <h4 class="event-alert mt-3">Completed Shifts </h4>
              
              <div class="shadowclass top_filters orderpayy mt-0 mb-3">
                <h4 class="event-alert py-0 my-2">Filters </h4>
                <div className="row mx-0">
                  <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                    <div class="calander d-flex align-items-center">
                      <div class="datePicker pading_right">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="from_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-01"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <div class="datePicker pading_lect">
                        <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                          <input
                            name="to_date"
                            class=" "
                            required="required"
                            type="text"
                            id=""
                            value="2022-05-13"
                          />
                          <span class="add-on">
                            <i class="fa fa-calendar"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                    
                  <MultiRangeSlider
                      min={0}
                      max={1000}
                      onChange={({ min, max }) =>
                        console.log(`min = ${min}, max = ${max}`)
                      }
                    />
                  </div>
                  <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                    <div class="select-div col px-1 pl-md-0">
                      <div class="input select">
                        <select
                          name="waste_group"
                          class="csutom_select"
                          id="WasteWasteGroup"
                        >
                          <option value="">Waste Group</option>
                          <option value="28">Food R&amp;D</option>
                        </select>
                      </div>{" "}
                    </div>
                    <div class="select-div col px-1">
                      <div class="input select">
                        <select
                          name="waste_type"
                          class="csutom_select"
                          id="WasteWasteType"
                        >
                          <option value="">Waste Type</option>
                          <option value="1">Waste Cost</option>
                          <option value="2">Waste Return</option>
                        </select>
                      </div>{" "}
                    </div>
                    <div class="select-div col px-1">
                      <div class="input select">
                        <select
                          name="supplier"
                          class="csutom_select"
                          id="WasteSupplier"
                        >
                          <option value="">Supplier</option>
                          <option value="6178">6 Drunk Men Pte Ltd</option>
                        </select>
                      </div>{" "}
                    </div>
                  </div>
                  <div class="col-lg-1 col px-0 pt-3 pt-lg-0">
                    <button class="btn btn_btnblue" type="submit">
                      Search
                    </button>
                  </div>
                </div>
              </div>{" "}
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <h4 class="event-alert"> Shifts For Review </h4>
                <div class="row justify-content-between align-items-center w-100 mx-0">
                  <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    <div class="search-box">
                      <form
                        action="/productions"
                        id="MenuItemIndexForm"
                        method="get"
                        accept-charset="utf-8"
                      >
                        {" "}
                        <input
                          name="keyword"
                          placeholder="Search"
                          type="text"
                          id="MenuItemKeyword"
                        />{" "}
                        <input type="submit" />
                      </form>
                    </div>{" "}
                  </div>
                </div>
              </div>
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <div class="shadowclass mt-0 p-0">
                      <div class="accordion">
                        <div class="table-responsive">
                          <table
                            class="checklist-table payroll-table shifts-table mt-0"
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tbody>
                              <tr class="bg-gry">
                                <td className="min-wd-150">
                                  <div class="d-flex">
                                    <span>
                                      <strong> Jasone's Shack! </strong>
                                      <br />
                                      Jul 14 2022{" "}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <strong> OT Hours </strong>
                                  <br /> 0{" "}
                                </td>
                                <td className="col-2">
                                  <strong> Total Hours </strong>
                                  <br /> 0.0833333{" "}
                                </td>
                                <td>
                                  <strong> Total Cost </strong>
                                  <br /> <small>$</small> 94.09{" "}
                                </td>
                                <td class="red-txt">
                                  <strong> Exceptions </strong>
                                  <br /> 0
                                </td>
                                <td align="center">
                                  <button
                                    class="dropdown-green hideFullShifts"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseOne"
                                    aria-expanded="false"
                                    aria-controls="flush-collapseOne"
                                  >
                                    {" "}
                                  </button>
                                </td>
                              </tr>
                              <tr
                                id="flush-collapseOne"
                                class="accordion-collapse collapse"
                              >
                                <td colspan="10" class="p-0 wht-table">
                                  <table class="table-sec w-100 accordion_table">
                                    <thead>
                                      <tr>
                                        <th> </th>
                                        <th>Shift Owner</th>
                                        <th>Account</th>
                                        <th>Shift Date</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Break</th>
                                        <th>Total Hours</th>
                                        <th>Total OT Hours</th>
                                        <th>Variance</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div class="imagediv pull-right">
                                            <img
                                              src="/img/no-image-found.png"
                                              alt="Darlene Simms"
                                              id="preview_451"
                                            />{" "}
                                          </div>
                                        </td>
                                        <td>
                                          {" "}
                                          <strong>Darlene Simms </strong>
                                          <br /> Sous Chef{" "}
                                        </td>
                                        <td class="w-auto">Jasone's Shack!</td>
                                        <td>Jul 14,2022</td>
                                        <td>12:44 PM</td>
                                        <td>12:44 PM</td>
                                        <td>0 Hrs</td>
                                        <td>0 Hrs </td>
                                        <td>0 Hrs</td>
                                        <td>
                                          <span class="arrow_symbol arrow_up">
                                            0 Mins
                                          </span>
                                        </td>
                                        <td>
                                          <a
                                            href="#_"
                                            class="link showDetails"
                                            type="button"
                                            role={"button"}
                                            data-bs-toggle="collapse"
                                            data-bs-target="#flush-collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="flush-collapseTwo"
                                          >
                                            Details
                                          </a>{" "}
                                        </td>
                                      </tr>

                                      <tr
                                        id="flush-collapseTwo"
                                        class="accordion-collapse collapse"
                                      >
                                        <td colspan="11" class="p-0 wht-table">
                                          <div class="inner-div-sec">
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <th>
                                                    <small>
                                                      {" "}
                                                      <strong>
                                                        Shift ID:
                                                      </strong>{" "}
                                                      13287{" "}
                                                    </small>
                                                  </th>
                                                  <th> Start </th>
                                                  <th> Break </th>
                                                  <th> End </th>
                                                  <th> Total </th>
                                                  <th> OT </th>
                                                  <th> Cost </th>
                                                  <th> </th>
                                                </tr>
                                                <tr>
                                                  <td>
                                                    {" "}
                                                    <strong>
                                                      {" "}
                                                      Scheduled{" "}
                                                    </strong>{" "}
                                                  </td>
                                                  <td> 12:40 PM </td>
                                                  <td class="w-auto"> 0 Hr </td>
                                                  <td> 12:45 PM </td>
                                                  <td> 0.08 Hrs </td>
                                                  <td> 0 Hrs </td>
                                                  <td>$94.09 </td>
                                                  <td> </td>
                                                </tr>
                                                <tr>
                                                  <td>
                                                    {" "}
                                                    <strong>
                                                      {" "}
                                                      Clock-In/Out{" "}
                                                    </strong>{" "}
                                                  </td>

                                                  <td> 12:44 PM </td>
                                                  <td class="w-auto"> 0 Hr </td>
                                                  <td> 12:44 PM </td>
                                                  <td>0.0833333 Hrs</td>
                                                  <td> 0 Hrs </td>
                                                  <td> $94.09 </td>
                                                </tr>
                                                <tr class="confirmed-tr">
                                                  <td>
                                                    {" "}
                                                    <strong> Confirmed </strong>
                                                  </td>
                                                  <td class="shift_start_time">
                                                    12:44 PM
                                                  </td>
                                                  <td class="w-auto">0 Hr </td>
                                                  <td class="shift_end_time">
                                                    12:44 PM{" "}
                                                  </td>
                                                  <td>0 Hrs</td>
                                                  <td> 0 Hrs </td>
                                                  <td> $94.09 </td>
                                                  <td>
                                                    {" "}
                                                    <a
                                                      class="circle_icon editShift"
                                                      href="#_"
                                                    >
                                                      {" "}
                                                      <i class="edit-icon iconSprites"></i>{" "}
                                                    </a>{" "}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>

                                            <div class="variance-cost">
                                              <div class="alncntr">
                                                <h5> Variance Cost </h5>
                                                <div>
                                                  {" "}
                                                  <span class="arrow_symbol right-arrow">
                                                    <small>$</small>0.00
                                                  </span>{" "}
                                                </div>
                                              </div>
                                            </div>

                                            <div class="right-comment-sec">
                                              <div
                                                class="shift_comments"
                                                id="45113287"
                                              >
                                                <p> No comment. </p>{" "}
                                                <div class="clear"> </div>
                                              </div>
                                              <a
                                                href="#_"
                                                class="comment-link"
                                                empid="451"
                                                siid="13287"
                                              >
                                                {" "}
                                                Comment{" "}
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default CompletedShifts;
